<template>
  <div class="coin">
    <div :id="`coin-${type}`"></div>
  </div>
</template>

<script>
import lottie from 'lottie-web/build/player/lottie';

export default {
  name: 'Coin',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    type: String,
  },
  computed: {
    totalCount() {
      return this.coinCount.pennies + this.coinCount.nickels + this.coinCount.dimes + this.coinCount.quarters;
    },
  },
  mounted() {
    lottie.loadAnimation({
      container: document.getElementById(`coin-${this.type}`),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: `/assets/practices/saving_money/animations/coin_${this.type}.json`,
    });
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.coin {
  // VARIABLES
  $coin-size: 20vh;

  // CSS
  @include flex-center;
  // background-color: blue;
  height: $coin-size;
  width: $coin-size;

  #coin-penny {
    height: 70%;
    width: 70%;
  }

  #coin-nickel {
    height: 80%;
    width: 80%;
  }
  #coin-dime {
    height: 65%;
    width: 65%;
  }

  #coin-quarter {
    height: $coin-size;
    width: $coin-size;
  }
}

@media (max-aspect-ratio: 8/5) {
  .coin {
    // VARIABLES
    $coin-size: 15vh;

    // CSS
    height: $coin-size;
    width: $coin-size;

    #coin-quarter {
      height: $coin-size;
      width: $coin-size;
    }
  }
}
</style>
